import { GuestType, useRegistrationData } from "@/store/useRegistrationData";

export const checkIsJapanResident = () => {
  return (
    localStorage.getItem(
      `${useRegistrationData.getState().signedOrderId}.guestType`,
    ) === GuestType.JapanResident
  );
};
